<script lang="ts">
	import Box from '$lib/components/boxes/Box.svelte';
	import type { OperationModel } from '@app/models/api/OperationModel';

	export let operation: OperationModel;
</script>

{#if operation.alerteDefiscalisation}
	<Box props={{ color: 'dashboardBg', classNames: 'space-y-3' }}>
		{@html operation.alerteDefiscalisation}
	</Box>
{/if}
